angular.module('impactx.productcoding').controller('ProductCodingListCtrl',  [
    '$scope',
    'dataGen',
    'selectedListItems',
    '$routeParams',
    '$mdDialog',
    '$listCache',
    'ListHelperService',
    ProductCodingListCtrl]);

function ProductCodingListCtrl($scope, dataGen, selectedListItems, $routeParams, $mdDialog, $listCache, ListHelperService)
{
    var self = this;
    self.comId = $routeParams.comId;

    this.import = function (event, trns) {
        $mdDialog.show({
            controller: "ProductCodingImportController",
            controllerAs: "productCodingImportController",
            templateUrl: "modules/productcoding/templates/product-coding-import.dialog.tmpl.html",
            parent: angular.element(document.body),
            targetEvent: event,
            clickOutsideToClose: true,
            bindToController: true,
            locals: {
                trns: trns
            }
        }).finally(function () {
            ListHelperService.refreshListData($scope, 'productCodingListCtrl');
        });
    };

    self.editEntries = function (event) {
        self.edit(event, selectedListItems.getSelectedItems());
    }

    self.edit = function (event, entries) {
        const newComId = parseInt(self.meta.params.listConfig.filterBlocks[0].filterValues[0].stringValue);
        if(newComId > 0) {
            self.comId = newComId;
        }
        $mdDialog.show({
            templateUrl: 'modules/productcoding/templates/product-coding-edit.dialog.tmpl.html',
            controller: "ProductCodingEditDialogCtrl",
            controllerAs: "productCodingEditDialogCtrl",
            targetEvent: event,
            locals: {
                entries: entries,
                comId: self.comId
            },
            bindToController: true,
            clickOutsideToClose: false
        }).finally(function () {
            ListHelperService.refreshListData($scope, 'productCodingListCtrl');
        });
    };


    var buttonDefinition = [
        {
            label: "import",
            action: self.import,
            condition: selectedListItems.isNoSelection,
            process: 'ProductCoding'
        },
        {
            label: "edit",
            action: self.editEntries,
            type: 'dialogaction',
            condition: !selectedListItems.isNoSelection,
            process: 'ProductCoding'
        },
    ];

    this.meta = {
        rowTemplate: 'modules/productcoding/templates/productcodinglist.row.tmpl.html',
        isSelectAble: true,
        ctrl: this,
        endpoint: '/productcoding/list',
        id: 'productcodinglist',
        buttonDefinition: buttonDefinition,
        hidePersistentListFilters: false,
        valuesInteger: [{name: "COM.Id", value: $routeParams.comId ? $routeParams.comId : 0},
                        {name: "VCAT.Id", value: $routeParams.vCatId ? $routeParams.vCatId : 0},
                        {name: "PRG.Id", value: $routeParams.prgId ? $routeParams.prgId : 0}]
    };

    this.getMeta = function () {
        return this.meta;
    };

    $listCache.remove(self.meta.id);
}